import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Home',
    href: '#home'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Areas',
    href: '#areas'
  }, {
    name: 'About',
    href: '#about'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  return <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md py-2' : 'bg-white/95 py-4'}`} data-id="element-145">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-146">
          <div className="flex justify-between items-center" data-id="element-147">
            {/* Logo */}
            <a href="#home" className="flex items-center gap-2 z-50" data-id="element-148">
              <img src="https://cdn.magicpatterns.com/uploads/rVq7c3x7YQ1uovr6qYGM9S/Photoroom_20260412_153537.png" alt="YEI Mateo Lawn Care Logo" className="h-12 w-auto object-contain" data-id="element-149" />
              <span className="font-heading font-bold text-xl text-primary hidden sm:block" data-id="element-150">
                YEI MATEO LAWN CARE
              </span>
            </a>

            {/* Desktop Nav */}
            <nav className="hidden md:flex items-center gap-8" data-id="element-151">
              {navLinks.map(link => <a key={link.name} href={link.href} className="text-darkCharcoal hover:text-primary font-medium transition-colors" data-id="element-152">
                  {link.name}
                </a>)}
            </nav>

            {/* Desktop CTA */}
            <div className="hidden md:flex items-center gap-6" data-id="element-153">
              <a href="tel:6192492966" className="flex items-center gap-2 text-darkCharcoal font-semibold hover:text-primary transition-colors" data-id="element-154">
                <Phone size={20} className="text-primary" data-id="element-155" />
                (619) 249-2966
              </a>
              <a href="#contact" className="bg-primary hover:bg-primary/90 text-white font-bold py-3 px-6 rounded-md transition-colors" data-id="element-156">
                GET FREE ESTIMATE
              </a>
            </div>

            {/* Mobile Menu Toggle */}
            <button className="md:hidden z-50 p-2 text-darkCharcoal" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-157">
              {mobileMenuOpen ? <X size={28} data-id="element-158" /> : <Menu size={28} data-id="element-159" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu Overlay */}
        <AnimatePresence data-id="element-160">
          {mobileMenuOpen && <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} className="absolute top-full left-0 right-0 bg-white shadow-lg border-t border-gray-100 md:hidden" data-id="element-161">
              <div className="flex flex-col px-4 py-6 space-y-4" data-id="element-162">
                {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="text-lg font-medium text-darkCharcoal py-2 border-b border-gray-100" data-id="element-163">
                    {link.name}
                  </a>)}
              </div>
            </motion.div>}
        </AnimatePresence>
      </header>

      {/* Mobile Sticky Bottom Bar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-primary text-white shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)]" data-id="element-164">
        <div className="flex items-center justify-between px-4 py-3" data-id="element-165">
          <a href="tel:6192492966" className="flex items-center gap-2 font-bold text-sm" data-id="element-166">
            <Phone size={18} data-id="element-167" />
            CALL NOW (619) 249-2966
          </a>
          <span className="text-white/50" data-id="element-168">|</span>
          <a href="#contact" className="font-bold text-sm" data-id="element-169">
            FREE ESTIMATE
          </a>
        </div>
      </div>
    </>;
}